import { render, staticRenderFns } from "./AccreditationInviteContainer.vue?vue&type=template&id=6c238a8f&scoped=true"
import script from "./AccreditationInviteContainer.vue?vue&type=script&lang=js"
export * from "./AccreditationInviteContainer.vue?vue&type=script&lang=js"
import style0 from "./AccreditationInviteContainer.vue?vue&type=style&index=0&id=6c238a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c238a8f",
  null
  
)

export default component.exports